module.exports = __webpack_public_path__ + "28b67065/img/placeholder.888fcd0b.svg";